export const routes = [
  ...require('./cadri/routes').routes,
  ...require('./consent-letter/routes').routes
]
